import * as React from "react";
const SvgFiRrHatWinter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hat-winter_svg__a)">
      <path
        fill="#062147"
        d="M21.902 17.298c-.529-5.153-3.464-11.675-8.137-13.028a2.5 2.5 0 1 0-3.53 0c-4.673 1.353-7.608 7.875-8.137 13.028A3.5 3.5 0 0 0 0 20.5C0 22.43 1.57 24 3.5 24h17c1.93 0 3.5-1.57 3.5-3.5 0-1.43-.865-2.66-2.098-3.202M12 6c3.856 0 7.163 5.605 7.864 11H4.136c.087-.667.217-1.337.38-2H16a1 1 0 1 0 0-2H5.126C6.533 9.151 9.11 6 12 6m8.5 16h-17c-.827 0-1.5-.673-1.5-1.5S2.673 19 3.5 19h17c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hat-winter_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHatWinter;
